import { FunctionComponent, ReactElement, useState } from "react";

// Components
import DataTable from "../../../shared/DataTable/DataTable";
import ExportSelectedClaimsButton from "../ExportSelectedClaimsButton";

// Utils
import { IParams } from "../../../shared/DataTable/hooks/useSearchParams";
import { DataTableColumn, KVP, PaginatedApiResponse, SortDirection } from "../../../utils/types";

interface ApprovedClaimsIndexTableProps {
	claimsData: PaginatedApiResponse;
	columns: Array<DataTableColumn>;
	searchParams: URLSearchParams;
	defaultParams?: Partial<IParams>;
	isLoading?: boolean;

	handleFetchClaims: (cacheKey: string) => void;
	handleManualRefetchTrigger: () => void;
}

const defaultClaimsParams: Partial<IParams> = {
	sortDirection: SortDirection.Desc,
	sortField: "id",
	searchField: "status",
	searchString: "Approved"
};

const ApprovedClaimsIndexTable: FunctionComponent<ApprovedClaimsIndexTableProps> = (
	props: ApprovedClaimsIndexTableProps
): ReactElement => {
	const { claimsData, columns, searchParams, defaultParams, isLoading, handleFetchClaims, handleManualRefetchTrigger } =
		props;
	const [selectedClaimIds, setSelectedClaimIds] = useState<Array<number>>([]);

	const getCustomHeader = (): ReactElement => {
		return <></>;
	};

	const getCustomSelectedActions = (selectedRows: Array<KVP>): ReactElement => {
		// Update selected claim IDs when selection changes
		const claimIds = selectedRows.map((row) => row.id as number);
		if (JSON.stringify(claimIds) !== JSON.stringify(selectedClaimIds)) {
			setSelectedClaimIds(claimIds);
		}

		return (
			<>
				<ExportSelectedClaimsButton selectedClaimIds={claimIds} onExport={handleManualRefetchTrigger} />
			</>
		);
	};

	return (
		<>
			<DataTable
				data={claimsData}
				columns={columns}
				refetchTrigger={handleFetchClaims}
				customHeaderActions={getCustomHeader()}
				customSelectedActions={getCustomSelectedActions}
				defaultParams={defaultParams || defaultClaimsParams}
				existingParams={searchParams}
				shouldUpdateUrl={true}
				isLoading={isLoading}
			/>
		</>
	);
};

export default ApprovedClaimsIndexTable;
